"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortIcon;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
function SortIcon(props) {
  let path = /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 853.333h341.333v-113.778h-341.333v113.778zM0 170.667v113.778h1024v-113.778h-1024zM0 568.889h682.667v-113.778h-682.667v113.778z"
  })));
  return path;
}
